/** Solo equivalencias editoriales publicadas. No inferir traducciones por slug. */
export const GUIDE_LANGUAGE_GROUPS = [
  { es: '/blog/como-llegar-a-tierra-bomba-desde-cartagena', en: '/en/tierra-bomba-from-cartagena' },
  { es: '/blog/como-llegar-a-playa-blanca-baru-cartagena', en: '/en/playa-blanca-baru-from-cartagena' },
  { es: '/tours/islas-del-rosario', en: '/en/rosario-islands-cartagena', pt: '/pt/ilhas-do-rosario-cartagena' },
  { es: '/tours/pasadias-cartagena', en: '/en/cartagena-day-trips' },
] as const;

export const NEW_TRAVEL_GUIDE_PATHS = [
  '/en/tierra-bomba-from-cartagena',
  '/en/playa-blanca-baru-from-cartagena',
  '/pt/ilhas-do-rosario-cartagena',
] as const;

export function guideLanguagePaths(path: string): Partial<Record<'es' | 'en' | 'pt', string>> | undefined {
  return GUIDE_LANGUAGE_GROUPS.find(group => Object.values(group).some(value => value === path));
}

export function guideLanguageAlternates(path: string, baseUrl: string) {
  const group = guideLanguagePaths(path);
  if (!group) return undefined;
  const base = baseUrl.replace(/\/$/, '');
  return Object.fromEntries([
    ...Object.entries(group).map(([lang, target]) => [lang, `${base}${target}`]),
    ['x-default', `${base}${group.es}`],
  ]);
}

/** Un acceso general se rotula como guías, no como traducción de un apartamento. */
export function englishGuideDestination(path: string) {
  return guideLanguagePaths(path)?.en ?? (path === '/tours/tierra-bomba'
    ? '/en/tierra-bomba-from-cartagena'
    : path === '/tours/baru' || path === '/tours/playa-blanca'
      ? '/en/playa-blanca-baru-from-cartagena' : '/en/cartagena-day-trips');
}
